import { RRule } from 'rrule';

export const getRruleInterval = (rrule: string) =>
  RRule.fromString(rrule).options.interval || 1;
